<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="chapter-title1"><a id="page_x"></a>OCTAVE DESIGNATION CHART</p>
<div class="block">
<p class="blockquote"><em>c'</em> = middle C <br/><em>c”</em> = one octave above middle C, etc. <br/><em>c</em> = one octave below middle C <br/><em>C</em> = two octaves below middle C <br/><em>C</em><sub>1</sub> = three octaves below middle C, etc.</p>
</div>
<p class="body-text">Instruments are often said to be “in” a specific pitch or key, meaning that their fundamental pitch or tone is the letter given. But “in” for early instruments is not always the same as for modern band and orchestral winds, for which anything other than “in C” implies they are transposing instruments. So it is entirely possible that you might have an alto recorder in <em>g</em> or a soprano in <em>d”</em>; a lute might be in <em>g</em> or <em>a.</em> With regard to lutes and viols, the pitch given in this book for their tonality is that of their top string; a lute “in” <em>a'</em>, for instance, has that pitch as its top course.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front1.vue?0409de36